import React, { useState, useEffect, useRef } from 'react';
import './NewProduct.css'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
import { getTotalStockFromItemStocks, hasConfiguredVariants as hasConfiguredVariantsInProduct } from '../../productStock';
import ProductDescriptionEditor from '../../ProductDescriptionEditor/ProductDescriptionEditor';
import ProductMedia from '../../ProductMedia/ProductMedia';
const STOCK_NO_NECESARIO_VALUE = 999999;
const VIDEO_MEDIA_ACCEPT = 'video/mp4,video/webm,video/ogg,video/quicktime';
const IMAGE_MEDIA_ACCEPT = 'image/*';

export default function NewProduct() {
    const imageInput1Ref = useRef(null);
    const imageInput2Ref = useRef(null);
    const imageInput3Ref = useRef(null);
    const imageInput4Ref = useRef(null);
    const imageInput5Ref = useRef(null);
    const imageInput6Ref = useRef(null);
    const imageInput7Ref = useRef(null);
    const imageInput8Ref = useRef(null);
    const imageInput9Ref = useRef(null);
    const imageInput10Ref = useRef(null);
    const [mensaje, setMensaje] = useState('');
    const [imagenPreview1, setImagenPreview1] = useState(null);
    const [imagenPreview2, setImagenPreview2] = useState(null);
    const [imagenPreview3, setImagenPreview3] = useState(null);
    const [imagenPreview4, setImagenPreview4] = useState(null);
    const [imagenPreview5, setImagenPreview5] = useState(null);
    const [imagenPreview6, setImagenPreview6] = useState(null);
    const [imagenPreview7, setImagenPreview7] = useState(null);
    const [imagenPreview8, setImagenPreview8] = useState(null);
    const [imagenPreview9, setImagenPreview9] = useState(null);
    const [imagenPreview10, setImagenPreview10] = useState(null);
    const [mediaType1, setMediaType1] = useState('');
    const [mediaType2, setMediaType2] = useState('');
    const [mediaType3, setMediaType3] = useState('');
    const [mediaType4, setMediaType4] = useState('');
    const [mediaType5, setMediaType5] = useState('');
    const [mediaType6, setMediaType6] = useState('');
    const [mediaType7, setMediaType7] = useState('');
    const [mediaType8, setMediaType8] = useState('');
    const [mediaType9, setMediaType9] = useState('');
    const [mediaType10, setMediaType10] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [titulo, setTitulo] = useState('');
    const [sku, setSku] = useState('');
    const [marca, setMarca] = useState('');
    const [categoria, setCategoria] = useState('');
    const [masVendido, setMasVendido] = useState('');
    const [precio, setPrecio] = useState('');
    const [precioPersonalizable, setPrecioPersonalizable] = useState('no');
    const [isImage1Selected, setIsImage1Selected] = useState(false);
    const [isImage2Selected, setIsImage2Selected] = useState(false);
    const [isImage3Selected, setIsImage3Selected] = useState(false);
    const [isImage4Selected, setIsImage4Selected] = useState(false);
    const [isImage5Selected, setIsImage5Selected] = useState(false);
    const [isImage6Selected, setIsImage6Selected] = useState(false);
    const [isImage7Selected, setIsImage7Selected] = useState(false);
    const [isImage8Selected, setIsImage8Selected] = useState(false);
    const [isImage9Selected, setIsImage9Selected] = useState(false);
    const [isImage10Selected, setIsImage10Selected] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedSection, setSelectedSection] = useState('producto');
    const [categorias, setCategoras] = useState([]);
    const [item1, setItem1] = useState('');
    const [item2, setItem2] = useState('');
    const [item3, setItem3] = useState('');
    const [item4, setItem4] = useState('');
    const [item5, setItem5] = useState('');
    const [item6, setItem6] = useState('');
    const [item7, setItem7] = useState('');
    const [item8, setItem8] = useState('');
    const [item9, setItem9] = useState('');
    const [item10, setItem10] = useState('');
    const [itemStocks, setItemStocks] = useState({
        itemStock1: '',
        itemStock2: '',
        itemStock3: '',
        itemStock4: '',
        itemStock5: '',
        itemStock6: '',
        itemStock7: '',
        itemStock8: '',
        itemStock9: '',
        itemStock10: '',
    });
    const [precioAnterior, setPrecioAnterior] = useState('');
    const [stockGeneral, setStockGeneral] = useState('');
    const [stockNoNecesario, setStockNoNecesario] = useState(false);
    const itemFields = [
        { legend: 'Item 1', value: item1, setValue: setItem1, stockKey: 'itemStock1' },
        { legend: 'Item 2', value: item2, setValue: setItem2, stockKey: 'itemStock2' },
        { legend: 'Item 3', value: item3, setValue: setItem3, stockKey: 'itemStock3' },
        { legend: 'Item 4', value: item4, setValue: setItem4, stockKey: 'itemStock4' },
        { legend: 'Item 5', value: item5, setValue: setItem5, stockKey: 'itemStock5' },
        { legend: 'Item 6', value: item6, setValue: setItem6, stockKey: 'itemStock6' },
        { legend: 'Item 7', value: item7, setValue: setItem7, stockKey: 'itemStock7' },
        { legend: 'Item 8', value: item8, setValue: setItem8, stockKey: 'itemStock8' },
        { legend: 'Item 9', value: item9, setValue: setItem9, stockKey: 'itemStock9' },
        { legend: 'Item 10', value: item10, setValue: setItem10, stockKey: 'itemStock10' },
    ];
    const totalStock = getTotalStockFromItemStocks(itemStocks);
    const hasConfiguredVariants = hasConfiguredVariantsInProduct({
        item1,
        item2,
        item3,
        item4,
        item5,
        item6,
        item7,
        item8,
        item9,
        item10,
        ...itemStocks,
    });
    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };
    const handleImagenChange = (event, setImagenPreview, setIsImageSelected, setMediaType) => {
        const file = event.target.files[0];

        if (file) {

            const previewURL = URL.createObjectURL(file);
            setImagenPreview(previewURL);
            setIsImageSelected(true);
            setMediaType(file.type);
        }
    };


    const crear = async () => {
        const form = document.getElementById("crearForm");
        const formData = new FormData(form);
        const isPrecioPersonalizable = precioPersonalizable === 'si';
        formData.set('precioPersonalizable', isPrecioPersonalizable ? '1' : '0');
        formData.set('stockNoNecesario', stockNoNecesario ? '1' : '0');
        formData.set('precio', isPrecioPersonalizable ? '0' : String(precio));
        formData.set('stock', stockNoNecesario ? String(STOCK_NO_NECESARIO_VALUE) : (hasConfiguredVariants ? String(totalStock) : String(stockGeneral || 0)));
        const resetForm = () => {
            form.reset();
            setImagenPreview1(null);
            setImagenPreview2(null);
            setImagenPreview3(null);
            setImagenPreview4(null);
            setImagenPreview5(null);
            setImagenPreview6(null);
            setImagenPreview7(null);
            setImagenPreview8(null);
            setImagenPreview9(null);
            setImagenPreview10(null);
            setMediaType1('');
            setMediaType2('');
            setMediaType3('');
            setMediaType4('');
            setMediaType5('');
            setMediaType6('');
            setMediaType7('');
            setMediaType8('');
            setMediaType9('');
            setMediaType10('');

            setIsImage1Selected(false);
            setIsImage2Selected(false);
            setIsImage3Selected(false);
            setIsImage4Selected(false);
            setIsImage5Selected(false);
            setIsImage6Selected(false);
            setIsImage7Selected(false);
            setIsImage8Selected(false);
            setIsImage9Selected(false);
            setIsImage10Selected(false);
            setTitulo('');
            setSku('');
            setMarca('');
            setPrecio('');
            setPrecioPersonalizable('no');
            setCategoria('');
            setMasVendido('');
            setDescripcion('');
            setPrecioAnterior('');
            setItem1('');
            setItem2('');
            setItem3('');
            setItem4('');
            setItem5('');
            setItem6('');
            setItem7('');
            setItem8('');
            setItem9('');
            setItem10('');
            setItemStocks({
                itemStock1: '',
                itemStock2: '',
                itemStock3: '',
                itemStock4: '',
                itemStock5: '',
                itemStock6: '',
                itemStock7: '',
                itemStock8: '',
                itemStock9: '',
                itemStock10: '',
            });
            setStockGeneral('');
            setStockNoNecesario(false);
            setSelectedSection('producto');
        };
        setMensaje('');

        if (

            !formData.get('titulo') ||
            !formData.get('idCategoria') ||
            !formData.get('masVendido') ||
            !formData.get('precioPersonalizable') ||
            (!isPrecioPersonalizable && !formData.get('precio')) ||
            (!stockNoNecesario && !hasConfiguredVariants && formData.get('stock') === '')
        ) {
            toast.error('Por favor, complete todos los campos correctamente.');
            setSelectedSection('producto');
            return;
        }

        const selectedMediaFiles = Array.from({ length: 10 }, (_, index) => formData.get(`imagen${index + 1}`))
            .filter((file) => file instanceof File && file.name);
        const selectedVideoCount = selectedMediaFiles.filter((file) => file.type.startsWith('video/')).length;
        const selectedInvalidVideoBox = [formData.get('imagen1'), formData.get('imagen2')]
            .some((file) => file instanceof File && file.name && !file.type.startsWith('video/'));
        const selectedInvalidImageBox = Array.from({ length: 8 }, (_, index) => formData.get(`imagen${index + 3}`))
            .some((file) => file instanceof File && file.name && !file.type.startsWith('image/'));

        if (selectedMediaFiles.length === 0) {
            toast.error('Selecciona al menos una imagen o video.');
            setSelectedSection('imagenes');
            return;
        }

        if (selectedInvalidVideoBox) {
            toast.error('Los cuadros de video solo aceptan videos.');
            setSelectedSection('imagenes');
            return;
        }

        if (selectedInvalidImageBox) {
            toast.error('Los cuadros de imagen solo aceptan imágenes.');
            setSelectedSection('imagenes');
            return;
        }

        if (selectedVideoCount > 2) {
            toast.error('Solo puedes subir hasta 2 videos por producto.');
            setSelectedSection('imagenes');
            return;
        }

        setMensaje('Procesando...');

        try {
            const response = await fetch(`${baseURL}/productosPost.php`, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.mensaje) {
                setMensaje('');
                resetForm();
                toast.success(data.mensaje);
                window.location.reload();
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error);
                console.log(data.error);

            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.');

        }
    };


    const handleCategoriaChange = (e) => {
        setCategoria(e.target.value);
    };
    const handleMasVendidoChange = (e) => {
        setMasVendido(e.target.value);
    };
    useEffect(() => {
        cargarCategoria();
    }, []);


    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategoras(data.categorias || []);
                console.log(data.categorias)
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const handleItemStockChange = (key, value) => {
        setItemStocks((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const clearSelectedImage = (inputRef, setPreview, setSelected, setMediaType) => {
        setPreview(null);
        setSelected(false);
        setMediaType('');
        if (inputRef.current) {
            inputRef.current.value = '';
        }
    };


    return (
        <div className='NewContain'>
            <button onClick={toggleModal} className='btnSave'>
                <span>  +</span> Agregar
            </button>
            {modalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal newProductModalTabsHeader'>
                            <div className='newProductTabs'>
                                <button
                                    type="button"
                                    className={selectedSection === 'producto' ? 'selected' : ''}
                                    onClick={() => setSelectedSection('producto')}
                                >
                                    Agregar Producto
                                </button>
                                <button
                                    type="button"
                                    className={selectedSection === 'imagenes' ? 'selected' : ''}
                                    onClick={() => setSelectedSection('imagenes')}
                                >
                                    Agregar Imágenes
                                </button>
                            </div>
                            <span className="close" onClick={toggleModal}>&times;</span>
                        </div>
                        <form id="crearForm">

                            <div className='flexGrap' style={{ display: selectedSection === 'producto' ? 'flex' : 'none' }}>
                                <fieldset>
                                    <legend>Título (obligatorio)</legend>
                                    <input
                                        type="text"
                                        id="titulo"
                                        name="titulo"
                                        required
                                        value={titulo}
                                        onChange={(e) => setTitulo(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>SKU</legend>
                                    <input
                                        type="text"
                                        id="sku"
                                        name="sku"
                                        value={sku}
                                        onChange={(e) => setSku(e.target.value)}
                                        placeholder="Ej: SKU-001"
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Marca</legend>
                                    <input
                                        type="text"
                                        id="marca"
                                        name="marca"
                                        value={marca}
                                        onChange={(e) => setMarca(e.target.value)}
                                        placeholder="Ej: Nike"
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Precio (obligatorio)</legend>
                                    <input
                                        type="number"
                                        id="precio"
                                        name="precio"
                                        min="0"
                                        step="0.01"
                                        required={precioPersonalizable === 'no'}
                                        value={precioPersonalizable === 'si' ? '' : precio}
                                        onChange={(e) => setPrecio(e.target.value)}
                                        disabled={precioPersonalizable === 'si'}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Precio personalizable (obligatorio)</legend>
                                    <select
                                        id="precioPersonalizable"
                                        name="precioPersonalizable"
                                        value={precioPersonalizable}
                                        onChange={(e) => setPrecioPersonalizable(e.target.value)}
                                        required
                                    >
                                        <option value="">Selecciona opción</option>
                                        <option value="si">Sí</option>
                                        <option value="no">No</option>
                                    </select>
                                    <small className='fieldHint'>Si eliges “Sí”, el precio se verá como “Personalizable” para negociar con el cliente.</small>
                                </fieldset>

                                <fieldset>
                                    <legend>Categoría (obligatorio)</legend>
                                    <select
                                        id="idCategoria"
                                        name="idCategoria"
                                        value={categoria}
                                        onChange={handleCategoriaChange}
                                    >
                                        <option value="">Selecciona una categoría</option>
                                        {categorias.map(item => (
                                            <option key={item.idCategoria} value={item.idCategoria}>{item.categoria}</option>
                                        ))}
                                    </select>
                                </fieldset>

                                <fieldset>
                                    <legend>Más vendido (obligatorio)</legend>
                                    <select
                                        id="masVendido"
                                        name="masVendido"
                                        value={masVendido}
                                        onChange={handleMasVendidoChange}
                                    >
                                        <option value="">Selecciona opcion</option>
                                        <option value="si">Si</option>
                                        <option value="no">No</option>

                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Stock total</legend>
                                    <input
                                        type="number"
                                        id="stock"
                                        name="stock"
                                        min="0"
                                        step="1"
                                        required={!stockNoNecesario && !hasConfiguredVariants}
                                        value={stockNoNecesario ? '' : (hasConfiguredVariants ? totalStock : stockGeneral)}
                                        onChange={(e) => setStockGeneral(e.target.value)}
                                        readOnly={hasConfiguredVariants}
                                        disabled={stockNoNecesario}
                                    />
                                </fieldset>
                                <fieldset className='checkboxField'>
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="stockNoNecesario"
                                            checked={stockNoNecesario}
                                            onChange={(e) => setStockNoNecesario(e.target.checked)}
                                        />
                                        Stock no necesario
                                    </label>
                                </fieldset>
                                <fieldset id='descripcion'>
                                    <legend>Descripción</legend>
                                    <ProductDescriptionEditor
                                        id="descripcion"
                                        name="descripcion"
                                        required
                                        value={descripcion}
                                        onChange={setDescripcion}
                                        placeholder="Descripción"
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Precio anterior</legend>
                                    <input
                                        type="number"
                                        id="precioAnterior"
                                        name="precioAnterior"
                                        min="0"
                                        step="0.01"
                                        required
                                        value={precioAnterior}
                                        onChange={(e) => setPrecioAnterior(e.target.value)}
                                    />
                                </fieldset>
                                <div className='items'>
                                    {itemFields.map((field, index) => (
                                        <fieldset key={field.legend}>
                                            <legend>{field.legend}</legend>
                                            <div className='itemInputGroup'>
                                                <span className='itemFieldLabel'>Talla</span>
                                                <input
                                                    type="text"
                                                    id={`item${index + 1}`}
                                                    name={`item${index + 1}`}
                                                    value={field.value}
                                                    onChange={(e) => field.setValue(e.target.value)}
                                                    placeholder='Ej: S'
                                                />
                                            </div>
                                            <div className='itemInputGroup'>
                                                <span className='itemFieldLabel'>Stock</span>
                                                <input
                                                    type="number"
                                                    name={field.stockKey}
                                                    min="0"
                                                    step="1"
                                                    value={itemStocks[field.stockKey]}
                                                    onChange={(e) => handleItemStockChange(field.stockKey, e.target.value)}
                                                    placeholder="0"
                                                    disabled={stockNoNecesario}
                                                />
                                            </div>
                                        </fieldset>
                                    ))}
                                </div>




                            </div>
                            <div className='flexGrap mediaTabPanel' style={{ display: selectedSection === 'imagenes' ? 'flex' : 'none' }}>
                                <fieldset>
                                    <legend>Video 1</legend>
                                    <small className='fieldHint'>Video MP4, WebM, OGG o MOV.</small>
                                    <input
                                        ref={imageInput1Ref}
                                        type="file"
                                        id="imagen1"
                                        name="imagen1"
                                        accept={VIDEO_MEDIA_ACCEPT}
                                        onChange={(e) => handleImagenChange(e, setImagenPreview1, setIsImage1Selected, setMediaType1)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Video 2</legend>
                                    <small className='fieldHint'>Video MP4, WebM, OGG o MOV.</small>
                                    <input
                                        ref={imageInput2Ref}
                                        type="file"
                                        id="imagen2"
                                        name="imagen2"
                                        accept={VIDEO_MEDIA_ACCEPT}
                                        onChange={(e) => handleImagenChange(e, setImagenPreview2, setIsImage2Selected, setMediaType2)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Imagen 1</legend>
                                    <small className='fieldHint'>Imagen recomendada: 1200 x 1200 px.</small>
                                    <input
                                        ref={imageInput3Ref}
                                        type="file"
                                        id="imagen3"
                                        name="imagen3"
                                        accept={IMAGE_MEDIA_ACCEPT}
                                        onChange={(e) => handleImagenChange(e, setImagenPreview3, setIsImage3Selected, setMediaType3)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Imagen 2</legend>
                                    <small className='fieldHint'>Imagen recomendada: 1200 x 1200 px.</small>

                                    <input
                                        ref={imageInput4Ref}
                                        type="file"
                                        id="imagen4"
                                        name="imagen4"
                                        accept={IMAGE_MEDIA_ACCEPT}
                                        onChange={(e) => handleImagenChange(e, setImagenPreview4, setIsImage4Selected, setMediaType4)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Imagen 3</legend>
                                    <small className='fieldHint'>Imagen recomendada: 1200 x 1200 px.</small>

                                    <input
                                        ref={imageInput5Ref}
                                        type="file"
                                        id="imagen5"
                                        name="imagen5"
                                        accept={IMAGE_MEDIA_ACCEPT}
                                        onChange={(e) => handleImagenChange(e, setImagenPreview5, setIsImage5Selected, setMediaType5)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Imagen 4</legend>
                                    <small className='fieldHint'>Imagen recomendada: 1200 x 1200 px.</small>

                                    <input
                                        ref={imageInput6Ref}
                                        type="file"
                                        id="imagen6"
                                        name="imagen6"
                                        accept={IMAGE_MEDIA_ACCEPT}
                                        onChange={(e) => handleImagenChange(e, setImagenPreview6, setIsImage6Selected, setMediaType6)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Imagen 5</legend>
                                    <small className='fieldHint'>Imagen recomendada: 1200 x 1200 px.</small>

                                    <input
                                        ref={imageInput7Ref}
                                        type="file"
                                        id="imagen7"
                                        name="imagen7"
                                        accept={IMAGE_MEDIA_ACCEPT}
                                        onChange={(e) => handleImagenChange(e, setImagenPreview7, setIsImage7Selected, setMediaType7)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Imagen 6</legend>
                                    <small className='fieldHint'>Imagen recomendada: 1200 x 1200 px.</small>

                                    <input
                                        ref={imageInput8Ref}
                                        type="file"
                                        id="imagen8"
                                        name="imagen8"
                                        accept={IMAGE_MEDIA_ACCEPT}
                                        onChange={(e) => handleImagenChange(e, setImagenPreview8, setIsImage8Selected, setMediaType8)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Imagen 7</legend>
                                    <small className='fieldHint'>Imagen recomendada: 1200 x 1200 px.</small>

                                    <input
                                        ref={imageInput9Ref}
                                        type="file"
                                        id="imagen9"
                                        name="imagen9"
                                        accept={IMAGE_MEDIA_ACCEPT}
                                        onChange={(e) => handleImagenChange(e, setImagenPreview9, setIsImage9Selected, setMediaType9)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Imagen 8</legend>
                                    <small className='fieldHint'>Imagen recomendada: 1200 x 1200 px.</small>

                                    <input
                                        ref={imageInput10Ref}
                                        type="file"
                                        id="imagen10"
                                        name="imagen10"
                                        accept={IMAGE_MEDIA_ACCEPT}
                                        onChange={(e) => handleImagenChange(e, setImagenPreview10, setIsImage10Selected, setMediaType10)}
                                    />
                                </fieldset>

                            </div>
                            {selectedSection === 'imagenes' && (isImage1Selected || isImage2Selected || isImage3Selected || isImage4Selected || isImage5Selected || isImage6Selected || isImage7Selected || isImage8Selected || isImage9Selected || isImage10Selected) &&
                                <div className='previevCategori'>
                                    {isImage1Selected && (
                                        <div className='previewImageCard'>
                                            <ProductMedia src={imagenPreview1} mediaType={mediaType1} alt="Vista previa 1" className="productMediaThumb" controls={mediaType1.startsWith('video/')} />
                                            <button type="button" className='removePreviewButton' onClick={() => clearSelectedImage(imageInput1Ref, setImagenPreview1, setIsImage1Selected, setMediaType1)}>
                                                Quitar
                                            </button>
                                        </div>
                                    )}
                                    {isImage2Selected && (
                                        <div className='previewImageCard'>
                                            <ProductMedia src={imagenPreview2} mediaType={mediaType2} alt="Vista previa 2" className="productMediaThumb" controls={mediaType2.startsWith('video/')} />
                                            <button type="button" className='removePreviewButton' onClick={() => clearSelectedImage(imageInput2Ref, setImagenPreview2, setIsImage2Selected, setMediaType2)}>
                                                Quitar
                                            </button>
                                        </div>
                                    )}
                                    {isImage3Selected && (
                                        <div className='previewImageCard'>
                                            <ProductMedia src={imagenPreview3} mediaType={mediaType3} alt="Vista previa 3" className="productMediaThumb" controls={mediaType3.startsWith('video/')} />
                                            <button type="button" className='removePreviewButton' onClick={() => clearSelectedImage(imageInput3Ref, setImagenPreview3, setIsImage3Selected, setMediaType3)}>
                                                Quitar
                                            </button>
                                        </div>
                                    )}
                                    {isImage4Selected && (
                                        <div className='previewImageCard'>
                                            <ProductMedia src={imagenPreview4} mediaType={mediaType4} alt="Vista previa 4" className="productMediaThumb" controls={mediaType4.startsWith('video/')} />
                                            <button type="button" className='removePreviewButton' onClick={() => clearSelectedImage(imageInput4Ref, setImagenPreview4, setIsImage4Selected, setMediaType4)}>
                                                Quitar
                                            </button>
                                        </div>
                                    )}
                                    {isImage5Selected && (
                                        <div className='previewImageCard'>
                                            <ProductMedia src={imagenPreview5} mediaType={mediaType5} alt="Vista previa 5" className="productMediaThumb" controls={mediaType5.startsWith('video/')} />
                                            <button type="button" className='removePreviewButton' onClick={() => clearSelectedImage(imageInput5Ref, setImagenPreview5, setIsImage5Selected, setMediaType5)}>
                                                Quitar
                                            </button>
                                        </div>
                                    )}
                                    {isImage6Selected && (
                                        <div className='previewImageCard'>
                                            <ProductMedia src={imagenPreview6} mediaType={mediaType6} alt="Vista previa 6" className="productMediaThumb" controls={mediaType6.startsWith('video/')} />
                                            <button type="button" className='removePreviewButton' onClick={() => clearSelectedImage(imageInput6Ref, setImagenPreview6, setIsImage6Selected, setMediaType6)}>
                                                Quitar
                                            </button>
                                        </div>
                                    )}
                                    {isImage7Selected && (
                                        <div className='previewImageCard'>
                                            <ProductMedia src={imagenPreview7} mediaType={mediaType7} alt="Vista previa 7" className="productMediaThumb" controls={mediaType7.startsWith('video/')} />
                                            <button type="button" className='removePreviewButton' onClick={() => clearSelectedImage(imageInput7Ref, setImagenPreview7, setIsImage7Selected, setMediaType7)}>
                                                Quitar
                                            </button>
                                        </div>
                                    )}
                                    {isImage8Selected && (
                                        <div className='previewImageCard'>
                                            <ProductMedia src={imagenPreview8} mediaType={mediaType8} alt="Vista previa 8" className="productMediaThumb" controls={mediaType8.startsWith('video/')} />
                                            <button type="button" className='removePreviewButton' onClick={() => clearSelectedImage(imageInput8Ref, setImagenPreview8, setIsImage8Selected, setMediaType8)}>
                                                Quitar
                                            </button>
                                        </div>
                                    )}
                                    {isImage9Selected && (
                                        <div className='previewImageCard'>
                                            <ProductMedia src={imagenPreview9} mediaType={mediaType9} alt="Vista previa 9" className="productMediaThumb" controls={mediaType9.startsWith('video/')} />
                                            <button type="button" className='removePreviewButton' onClick={() => clearSelectedImage(imageInput9Ref, setImagenPreview9, setIsImage9Selected, setMediaType9)}>
                                                Quitar
                                            </button>
                                        </div>
                                    )}
                                    {isImage10Selected && (
                                        <div className='previewImageCard'>
                                            <ProductMedia src={imagenPreview10} mediaType={mediaType10} alt="Vista previa 10" className="productMediaThumb" controls={mediaType10.startsWith('video/')} />
                                            <button type="button" className='removePreviewButton' onClick={() => clearSelectedImage(imageInput10Ref, setImagenPreview10, setIsImage10Selected, setMediaType10)}>
                                                Quitar
                                            </button>
                                        </div>
                                    )}
                                </div>
                            }
                            {mensaje ? (
                                <button type="button" className='btnLoading' disabled>
                                    {mensaje}
                                </button>
                            ) : (
                                <button type="button" onClick={crear} className='btnPost'>
                                    Agregar
                                </button>
                            )}


                        </form>
                    </div>
                </div>
            )}

        </div>
    );
}

